import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardPage } from './dashboard.page';
import { GraphyComponent } from './graphy/graphy.component';
import { PrescriptionComponent } from './prescription/prescription.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardPage,
    children:[
      {
        path: 'graphy',
        component: GraphyComponent
      },
      {
        path: 'prescription',
        component: PrescriptionComponent
      },
      {
        path: '',
        redirectTo: '/dashboard/graphy',
        pathMatch: 'full'
      },
      {
        path: '**',
        redirectTo: '/dashboard/graphy',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardPageRoutingModule {}
